export const colors = {
  primary: "#49b152", // Green
  secondary: "#023047", // Dark Blue
  white: "#FFFFFF", // White
  black: "#000000", // Black
  red: "#FF0000", // Red
  blue: "#0000FF", // Blue
  gray: "#808080", // Gray
  lightgray: "#D3D3D3", // Light Gray
  error: "#f44336", // Red for error messages
  orange: "#f7b443",
  darkBackground: "#555252",
};
document.documentElement.style.setProperty("--primary-color", colors.primary);
document.documentElement.style.setProperty(
  "--secondary-color",
  colors.secondary
);
